//React
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
//Libraries
import cx from "classnames";
//Components
import {
  Accordion,
  Card,
  DocsCodeBlock,
  DocsFlexSectionBlock,
  DocsScreen,
  FlexBox,
  removeLoader,
  showLoader,
  StatusMark,
  TitleBlock,
  Image,
} from "components";
//Constants
import { docsConstants } from "../../../constants";
//Utils
import { titleCase, useIsInViewport } from "utils";
//Styles
import "./styles.scss";
//Assets
import RestApiIcon from "assets/icons/rest-api.svg";

import RightArrowImg from "assets/icons/down-arrow.png";
import ROUTE_PATH from "Routes/paths";

const requestCodeToBeCopiedMap = {
  Node: `
var request = require('request');
var options = {
  'method': '${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE}',
  'url': '${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}',
  'headers': {
    'appId': '{{appId}}',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    "loginMethod": "WHATSAPP",
    "redirectionURL": "YOUR_REDIRECTION_URL_HERE",
    "state": "YOUR_STATE_HERE"
  })
};
request(options, function (error, response) {
  if (error) throw new Error(error);
  console.log(response.body);
});
  `,
  Go: `
package main

import (
  "fmt"
  "strings"
  "net/http"
  "io/ioutil"
)

func main() {

  url := "${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}"
  method := "${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE}"

  payload := strings.NewReader("{
    "loginMethod":"WHATSAPP",
    "redirectionURL":"YOUR_REDIRECTION_URL_HERE",
    "state":"YOUR_STATE_HERE"
}")

  client := &http.Client {
  }
  req, err := http.NewRequest(method, url, payload)

  if err != nil {
    fmt.Println(err)
    return
  }
  req.Header.Add("appId", "{{appId}}")
  req.Header.Add("Content-Type", "application/json")

  res, err := client.Do(req)
  if err != nil {
    fmt.Println(err)
    return
  }
  defer res.Body.Close()

  body, err := ioutil.ReadAll(res.Body)
  if err != nil {
    fmt.Println(err)
    return
  }
  fmt.Println(string(body))
}
  `,
  Python: `
import requests
import json

url = "${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}"

payload = json.dumps({
  "loginMethod": "WHATSAPP",
  "redirectionURL": "YOUR_REDIRECTION_URL_HERE",
  "state": "YOUR_STATE_HERE"
})
headers = {
  'appId': '{{appId}}',
  'Content-Type': 'application/json'
}

response = requests.request("${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE}", url, headers=headers, data=payload)

print(response.text)
  `,
  Ruby: `
require "uri"
require "json"
require "net/http"

url = URI("${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::${titleCase(
    docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE
  )}.new(url)
request["appId"] = "{{appId}}"
request["Content-Type"] = "application/json"
request.body = JSON.dump({
  "loginMethod": "WHATSAPP",
  "redirectionURL": "YOUR_REDIRECTION_URL_HERE",
  "state": "YOUR_STATE_HERE"
})

response = https.request(request)
puts response.read_body
  `,
  cURL: `curl --location --request ${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE} '${docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}' \
    --header 'appId: {YOUR_APP_ID}' \
    --header 'Content-Type: application/json' \
    --data-raw '{
        "loginMethod":"WHATSAPP",
        "redirectionURL":"YOUR_REDIRECTION_URL",
        "state": "YOUR_STATE",
        "orderId": "YOUR_ORDER_ID"
    }'
  `,
};

const requestGetUserDetailsCodeToBeCopiedMap = {
  Node: `
var request = require('request');
var options = {
  'method': '${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE}',
  'url': '${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}',
  'headers': {
    'appId': '{{appId}}',
    'appSecret': '{{appSecret}}',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    "token": "YOUR_TOKEN_HERE",
    "state": "STATE_PASSED_IN_GET_URL_CALL_HERE"
  })

};
request(options, function (error, response) {
  if (error) throw new Error(error);
  console.log(response.body);
});
  `,
  Go: `
package main

import (
  "fmt"
  "strings"
  "net/http"
  "io/ioutil"
)

func main() {

  url := "${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}"
  method := "${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE}"

  payload := strings.NewReader("{
    "token":"YOUR_TOKEN_HERE",
    "state":"STATE_PASSED_IN_GET_URL_CALL_HERE"
}")

  client := &http.Client {
  }
  req, err := http.NewRequest(method, url, payload)

  if err != nil {
    fmt.Println(err)
    return
  }
  req.Header.Add("appId", "{{appId}}")
  req.Header.Add("appSecret", "{{appSecret}}")
  req.Header.Add("Content-Type", "application/json")

  res, err := client.Do(req)
  if err != nil {
    fmt.Println(err)
    return
  }
  defer res.Body.Close()

  body, err := ioutil.ReadAll(res.Body)
  if err != nil {
    fmt.Println(err)
    return
  }
  fmt.Println(string(body))
}
  `,
  Python: `
import requests
import json

url = "${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}"

payload = json.dumps({
  "token": "YOUR_TOKEN_HERE",
  "state": "STATE_PASSED_IN_GET_URL_CALL_HERE"
})
headers = {
  'appId': '{{appId}}',
  'appSecret': '{{appSecret}}',
  'Content-Type': 'application/json'
}

response = requests.request("${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE}", url, headers=headers, data=payload)

print(response.text)
  `,
  Ruby: `
require "uri"
require "json"
require "net/http"

url = URI("${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::${titleCase(
    docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE
  )}.new(url)
request["appId"] = "{{appId}}"
request["appSecret"] = "{{appSecret}}"
request["Content-Type"] = "application/json"
request.body = JSON.dump({
  "token": "YOUR_TOKEN_HERE",
  "state": "STATE_PASSED_IN_GET_URL_CALL_HERE"
})

response = https.request(request)
puts response.read_body
  `,
  cURL: `curl --location --request ${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE} '${docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}' \
  --header 'appId: {YOUR_APP_ID}' \
  --header 'appSecret: {YOUR_APP_SECRET}' \
  --data-raw '{
      "token": "YOUR_TOKEN",
      "state": "STATE_PASSED_IN_INITIATE_CALL"
  }'
`,
};

const DocsHome = () => {
  /* Constants */
  //States
  const [scrolledToElement, setScrolledToElement]: any = useState({
    selectedTab: docsConstants.TITLES.API_REFERENCE.TITLE,
  });
  const [activeRequestLanguage, setActiveRequestLanguage] = useState("cURL");
  const [dropdownOpened, setDropdownOpened] = useState(false);

  const requestLanguage = ["Node", "Go", "Python", "Ruby", "cURL"];

  //Params
  const sdkType: any = useParams();

  //Refs
  const WelcomeSectionRef: any = useRef();
  const isWelcomeSectionInViewport = useIsInViewport(WelcomeSectionRef);
  //Rest Api
  const GetSignupUrlRef: any = useRef();
  const isGetSignupUrlInViewport = useIsInViewport(GetSignupUrlRef);
  const GetUserDetailsRef: any = useRef();
  const isGetUserDetailsInViewport = useIsInViewport(GetUserDetailsRef);
  const PostmanRef: any = useRef();
  const isPostmanInViewport = useIsInViewport(PostmanRef);

  //Jsons
  const scrollAccToSpecificElementMap = {
    [docsConstants.TITLES.API_REFERENCE.TITLE]: WelcomeSectionRef,
    [docsConstants.TITLES.REST_API.INITIATE_LOGIN]: GetSignupUrlRef,
    [docsConstants.TITLES.REST_API.GET_USER_API]: GetUserDetailsRef,
    [docsConstants.TITLES.REST_API.POSTMAN_COLLECTION]: PostmanRef,
  };

  /* useEffects */
  useEffect(() => {
    if (isWelcomeSectionInViewport) {
      setScrolledToElement({
        selectedTab: docsConstants.TITLES.API_REFERENCE.TITLE,
      });
    } else if (isGetSignupUrlInViewport) {
      setScrolledToElement({
        selectedTab: docsConstants.TITLES.REST_API.INITIATE_LOGIN,
        selectedParentTab: docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
        selectedGRandParentTab: docsConstants.TITLES.SDK_AND_API_REFERENCE,
      });
    } else if (isGetUserDetailsInViewport) {
      setScrolledToElement({
        selectedTab: docsConstants.TITLES.REST_API.GET_USER_API,
        selectedParentTab: docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
        selectedGRandParentTab: docsConstants.TITLES.SDK_AND_API_REFERENCE,
      });
    } else if (isPostmanInViewport) {
      setScrolledToElement({
        selectedTab: docsConstants.TITLES.REST_API.POSTMAN_COLLECTION,
        selectedParentTab: docsConstants.TITLES.LOGIN_WITH_WHATSAPP,
        selectedGRandParentTab: docsConstants.TITLES.SDK_AND_API_REFERENCE,
      });
    }
  }, [
    isWelcomeSectionInViewport,
    //rest api
    isGetSignupUrlInViewport,
    isGetUserDetailsInViewport,
    isPostmanInViewport,
  ]);

  /* Functions */
  //Scroll To Specific element
  const scrollToSpecificElement = (selectedTab) => {
    scrollAccToSpecificElementMap[selectedTab]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  //Render UI
  const getRequestHeader = (api: string) => {
    return (
      <>
        <p>Request</p>
        <div className="pos-rel">
          <FlexBox
            justifyEnd
            alignCenter
            className="clicking-animation"
            onClick={() => {
              setDropdownOpened((dropdownOpened) => !dropdownOpened);
            }}
          >
            <p className="fs-16">{activeRequestLanguage}</p>
            <Image
              src={RightArrowImg}
              className={cx(
                dropdownOpened && "rotate180",
                "transition right-arrow"
              )}
            />
          </FlexBox>
          <div
            className={cx(
              dropdownOpened && "dropdown-list-opened",
              "dropdown-list bg-white br-9"
            )}
          >
            {requestLanguage.map((item: string, index: number) => {
              return (
                <FlexBox
                  alignCenter
                  className={cx(
                    index !== 0 && "border-top",
                    item === activeRequestLanguage && "active",
                    "pd-10 clicking-animation"
                  )}
                  onClick={() => {
                    setActiveRequestLanguage(item);
                    setDropdownOpened(false);
                  }}
                >
                  <StatusMark status="SUCCESS" />
                  <p className={cx("fs-16 text-center font-medium")}>{item}</p>
                </FlexBox>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  const GetSignupUrlCode = () => {
    const curlCode = (
      <>
        <p>
          <span className="punctuation">curl</span>
          <span className="attr-name mr-h-5">--request</span>
          <span className="attr-value">
            {docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE}
          </span>{" "}
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--url</span>
          <span className="attr-value">
            '{docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}'
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--header</span>{" "}
          <span className="attr-value">'Content-Type: application/json' </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--header</span>{" "}
          <span className="attr-value">'appId: &#123;YOUR_APP_ID&#125;' </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--data-raw</span> '
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"loginMethod"</span>:{" "}
          <span className="attr-value mr-h-5">"WHATSAPP"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"redirectionURL"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_REDIRECTION_URL"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_STATE"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"orderId"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_ORDER_ID"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;</span>'
        </p>
      </>
    );

    const rubyCode = (
      <>
        <p>
          <span className="attr-name">require</span>
          <span className="attr-value"> "uri"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">require</span>
          <span className="attr-value"> "json"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">require</span>
          <span className="attr-value"> "net/http"</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">url</span>{" "}
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">URI</span>
          <span className="tag">(</span>
          <span className="tag">"</span>
          <span className="attr-value">
            {docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}
          </span>
          <span className="tag">"</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">https</span>{" "}
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">Net</span>
          <span className="tag mr-h-5">::</span>
          <span className="attr-name">HTTP</span>
          <span className="tag">.</span>
          <span className="attr-value">new</span>
          <span className="tag">(</span>
          <span className="attr-value">url.host</span>
          <span className="tag">,</span>
          <span className="attr-value mr-l-5">url.port</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">https</span>
          <span className="tag">.</span>
          <span className="attr-value">use_ssl</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-value">true</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">request</span>{" "}
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">Net</span>
          <span className="tag mr-h-5">::</span>
          <span className="punctuation">HTTP</span>
          <span className="tag mr-h-5">::</span>
          <span className="attr-name">
            {titleCase(docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE)}
          </span>
          <span className="tag">.</span>
          <span className="attr-value">new</span>
          <span className="tag">(</span>
          <span className="attr-value">url</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">["</span>
          <span className="attr-value">appId</span>
          <span className="tag">"]</span>
          <span className="tag mr-h-5">=</span>
          <span className="tag">"&#123;&#123;</span>
          <span className="attr-value">appId</span>
          <span className="tag">&#125;&#125;"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">["</span>
          <span className="attr-value">Content-Type</span>
          <span className="tag">"]</span>
          <span className="tag mr-h-5">=</span>
          <span className="tag">"</span>
          <span className="attr-value">application/json</span>
          <span className="tag">"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">.</span>
          <span className="attr-value">body</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-name">JSON</span>
          <span className="tag">.</span>
          <span className="attr-value">dump</span>
          <span className="tag">(&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"loginMethod"</span>:{" "}
          <span className="attr-value mr-h-5">"WHATSAPP"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"redirectionURL"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_REDIRECTION_URL_HERE"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_STATE_HERE"</span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">response</span>{" "}
          <span className="tag">=</span>
          <span className="attr-name">https</span>
          <span className="tag">.</span>
          <span className="attr-value">request</span>
          <span className="tag">(</span>
          <span className="attr-value">request</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">puts</span>
          <span className="attr-name mr-l-5">response</span>
          <span className="tag">.</span>
          <span className="attr-value">read_body</span>
        </p>
      </>
    );

    const pythonCode = (
      <>
        <p>
          <span className="attr-name">import</span>
          <span className="attr-value"> requests</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">import</span>
          <span className="attr-value"> json</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">url</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-value">
            {" "}
            {docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}
          </span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">payload</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-name">json</span>
          <span className="tag">.</span>
          <span className="attr-value">dumps</span>
          <span className="tag">(&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"loginMethod"</span>:{" "}
          <span className="attr-value mr-h-5">"WHATSAPP"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"redirectionURL"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_REDIRECTION_URL_HERE"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_STATE_HERE"</span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">headers</span>
          <span className="tag mr-h-5">=</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"appId"</span>:{" "}
          <span className="attr-value mr-h-5">
            "&#123;&#123;appId&#125;&#125;"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"Content-Type"</span>:{" "}
          <span className="attr-value mr-h-5">"application/json"</span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">response</span>{" "}
          <span className="mr-h-5 tag">=</span>
          <span className="attr-name">response</span>
          <span className="tag">.</span>
          <span className="attr-value">request</span>
          <span className="tag">(</span>
          <span className="attr-value">
            "{docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE}"
          </span>
          <span className="tag">,</span>
          <span className="attr-value mr-l-5">url</span>
          <span className="tag">,</span>
          <span className="attr-name mr-l-5">headers</span>
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">headers</span>
          <span className="tag">,</span>
          <span className="attr-name mr-l-5">data</span>
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">payload</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-value">print</span>
          <span className="tag">(</span>
          <span className="attr-name">response</span>
          <span className="tag">.</span>
          <span className="attr-value">text</span>
          <span className="tag">)</span>
        </p>
      </>
    );

    const goCode = (
      <>
        <p>
          <span className="attr-name">package</span>
          <span className="attr-value"> main</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">import</span>
          <span className="tag mr-l-5"> (</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-value">"fmt"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-value">"strings"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-value">"net/http"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-value">"io/ioutil"</span>
        </p>
        <p className="mr-t-5">
          <span className="tag"> )</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">fun</span>
          <span className="attr-value mr-h-5">main</span>
          <span className="tag">()</span>
          <span className="tag mr-h-5">&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">url</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-value mr-h-5">
            "{docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">method</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-value mr-h-5">
            "{docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE}"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">payload</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">strings</span>
          <span className="tag">.</span>
          <span className="attr-value">NewReader</span>
          <span className="tag">(`&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"loginMethod"</span>:{" "}
          <span className="attr-value mr-h-5">"WHATSAPP"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"redirectionURL"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_REDIRECTION_URL_HERE"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_STATE_HERE"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;`)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">client</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">http</span>
          <span className="tag">.</span>
          <span className="attr-value">Client</span>
          <span className="tag mr-l-5">&#123;</span>
        </p>
        <p className="mr-l-20">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">req</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">err</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">http</span>
          <span className="tag">.</span>
          <span className="attr-value">NewRequest</span>
          <span className="tag">(</span>
          <span className="attr-name">method</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">url</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">payload</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">if</span>
          <span className="attr-name mr-h-5">err</span>
          <span className="tag">!=</span>
          <span className="attr-name mr-h-5">nil</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">fmt</span>
          <span className="tag">.</span>
          <span className="attr-value">Println</span>
          <span className="tag">(</span>
          <span className="attr-value">err</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">return</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">req.</span>
          <span className="tag">.</span>
          <span className="attr-name">Header</span>
          <span className="tag">.</span>
          <span className="attr-value">Add</span>
          <span className="tag">(</span>
          <span className="attr-name">"appId"</span>:{" "}
          <span className="tag mr-r-5">,</span>
          <span className="attr-value">"&#123;&#123;appId&#125;&#125;"</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">req.</span>
          <span className="tag">.</span>
          <span className="attr-name">Header</span>
          <span className="tag">.</span>
          <span className="attr-value">Add</span>
          <span className="tag">(</span>
          <span className="attr-name">"Content-Type"</span>:{" "}
          <span className="tag mr-r-5">,</span>
          <span className="attr-value">"application/json"</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">req</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">err</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">client</span>
          <span className="tag">.</span>
          <span className="attr-value">Do</span>
          <span className="tag">(</span>
          <span className="attr-value">req</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">if</span>
          <span className="attr-name mr-h-5">err</span>
          <span className="tag">!=</span>
          <span className="attr-name mr-h-5">nil</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">fmt</span>
          <span className="tag">.</span>
          <span className="attr-value">Println</span>
          <span className="tag">(</span>
          <span className="attr-value">err</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">return</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">defer</span>
          <span className="attr-name mr-l-5">res</span>
          <span className="tag">.</span>
          <span className="attr-value">Body</span>
          <span className="tag">.</span>
          <span className="attr-value">Close</span>
          <span className="tag">()</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">body</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">err</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">ioutil</span>
          <span className="tag">.</span>
          <span className="attr-value">ReadAll</span>
          <span className="tag">(</span>
          <span className="attr-name">res</span>
          <span className="tag">.</span>
          <span className="attr-value">Body</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">if</span>
          <span className="attr-name mr-h-5">err</span>
          <span className="tag">!=</span>
          <span className="attr-name mr-h-5">nil</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">fmt</span>
          <span className="tag">.</span>
          <span className="attr-value">Println</span>
          <span className="tag">(</span>
          <span className="attr-value">err</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">return</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">fmt</span>
          <span className="tag">.</span>
          <span className="attr-value">Println</span>
          <span className="tag">(</span>
          <span className="attr-name">string</span>
          <span className="tag">(</span>
          <span className="attr-value">body</span>
          <span className="tag">)</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;</span>
        </p>
      </>
    );

    const nodeCode = (
      <>
        <p>
          <span className="punctuation">var</span>
          <span className="attr-name mr-l-5">request</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-name">require</span>
          <span className="tag ">(</span>
          <span className="attr-value">'request'</span>
          <span className="tag ">)</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">var</span>
          <span className="attr-name mr-l-5">options</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-name">&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">method:</span>
          <span className="attr-value">
            '{docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE}'
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">url:</span>
          <span className="attr-value">
            '{docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}'
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">headers:</span>
          <span className="tag mr-h-5">:</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"appId"</span>:{" "}
          <span className="attr-value mr-h-5">
            "&#123;&#123;appId&#125;&#125;"
          </span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"Content-Type"</span>:{" "}
          <span className="attr-value mr-h-5">"application/json"</span>
        </p>
        <p className="mr-l-20">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">body</span>
          <span className="tag mr-h-5">:</span>
          <span className="attr-name">JSON</span>
          <span className="tag">.</span>
          <span className="attr-value">stringify</span>
          <span className="tag">(&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"loginMethod"</span>:{" "}
          <span className="attr-value mr-h-5">"WHATSAPP"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"redirectionURL"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_REDIRECTION_URL"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_STATE"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;)</span>'
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;</span>'
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">(</span>
          <span className="attr-value">options</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-value">function</span>
          <span className="tag">(</span>
          <span className="attr-value">error</span>
          <span className="tag mr-r-5">,</span>
          <span className="tag">)</span>
          <span className="tag mr-l-5">&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">if</span>
          <span className="tag mr-l-5">(</span>
          <span className="attr-value">error</span>
          <span className="tag">)</span>
          <span className="punctuation mr-h-5">throw</span>
          <span className="attr-name mr-h-5">new</span>
          <span className="attr-value mr-h-5">Error</span>
          <span className="tag mr-l-5">(</span>
          <span className="attr-value">error</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">conosle</span>
          <span className="tag">.</span>
          <span className="attr-value">log</span>
          <span className="tag">(</span>
          <span className="attr-name mr-h-5">response</span>
          <span className="tag">.</span>
          <span className="attr-value">body</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;)</span>
        </p>
      </>
    );

    const codeMap = {
      cURL: curlCode,
      Ruby: rubyCode,
      Python: pythonCode,
      Go: goCode,
      Node: nodeCode,
    };
    return codeMap[activeRequestLanguage];
  };

  const GetUserDetailsCode = () => {
    const curlCode = (
      <>
        <p>
          <span className="punctuation">curl</span>
          <span className="attr-name mr-h-5">--location --request</span>
          <span className="attr-value"> POST </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--url</span>
          <span className="attr-value">
            'https://api.otpless.app/v1/client/user/session/userdata' \
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--header</span>{" "}
          <span className="attr-value">'Content-Type: application/json' </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--header</span>{" "}
          <span className="attr-value">'appId: &#123;YOUR_APP_ID&#125;' </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--header</span>{" "}
          <span className="attr-value">
            'appSecret: &#123;YOUR_APP_SECRET&#125;'{" "}
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">--data-raw</span> '
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"token"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_TOKEN"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">
            "STATE_PASSED_IN_INITIATE_CALL"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;</span>'
        </p>
      </>
    );

    const rubyCode = (
      <>
        <p>
          <span className="attr-name">require</span>
          <span className="attr-value"> "uri"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">require</span>
          <span className="attr-value"> "json"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">require</span>
          <span className="attr-value"> "net/http"</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">url</span>{" "}
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">URI</span>
          <span className="tag">(</span>
          <span className="tag">"</span>
          <span className="attr-value">
            {docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}
          </span>
          <span className="tag">"</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">https</span>{" "}
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">Net</span>
          <span className="tag mr-h-5">::</span>
          <span className="attr-name">HTTP</span>
          <span className="tag">.</span>
          <span className="attr-value">new</span>
          <span className="tag">(</span>
          <span className="attr-value">url.host</span>
          <span className="tag">,</span>
          <span className="attr-value mr-l-5">url.port</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">https</span>
          <span className="tag">.</span>
          <span className="attr-value">use_ssl</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-value">true</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">request</span>{" "}
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">Net</span>
          <span className="tag mr-h-5">::</span>
          <span className="punctuation">HTTP</span>
          <span className="tag mr-h-5">::</span>
          <span className="attr-name">
            {titleCase(docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE)}
          </span>
          <span className="tag">.</span>
          <span className="attr-value">new</span>
          <span className="tag">(</span>
          <span className="attr-value">url</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">["</span>
          <span className="attr-value">appId</span>
          <span className="tag">"]</span>
          <span className="tag mr-h-5">=</span>
          <span className="tag">"&#123;&#123;</span>
          <span className="attr-value">appId</span>
          <span className="tag">&#125;&#125;"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">["</span>
          <span className="attr-value">appSecret</span>
          <span className="tag">"]</span>
          <span className="tag mr-h-5">=</span>
          <span className="tag">"&#123;&#123;</span>
          <span className="attr-value">appSecret</span>
          <span className="tag">&#125;&#125;"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">["</span>
          <span className="attr-value">Content-Type</span>
          <span className="tag">"]</span>
          <span className="tag mr-h-5">=</span>
          <span className="tag">"</span>
          <span className="attr-value">application/json</span>
          <span className="tag">"</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">.</span>
          <span className="attr-value">body</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-name">JSON</span>
          <span className="tag">.</span>
          <span className="attr-value">dump</span>
          <span className="tag">(&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"token"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_TOKEN_HERE"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">
            "STATE_PASSED_IN_GET_URL_CALL_HERE"
          </span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">response</span>{" "}
          <span className="tag">=</span>
          <span className="attr-name">https</span>
          <span className="tag">.</span>
          <span className="attr-value">request</span>
          <span className="tag">(</span>
          <span className="attr-value">request</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">puts</span>
          <span className="attr-name mr-l-5">response</span>
          <span className="tag">.</span>
          <span className="attr-value">read_body</span>
        </p>
      </>
    );

    const pythonCode = (
      <>
        <p>
          <span className="attr-name">import</span>
          <span className="attr-value"> requests</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">import</span>
          <span className="attr-value"> json</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">url</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-value">
            {" "}
            {docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}
          </span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">payload</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-name">json</span>
          <span className="tag">.</span>
          <span className="attr-value">dumps</span>
          <span className="tag">(&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"token"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_TOKEN_HERE"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">
            "STATE_PASSED_IN_GET_URL_CALL_HERE"
          </span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">headers</span>
          <span className="tag mr-h-5">=</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"appId"</span>:{" "}
          <span className="attr-value mr-h-5">
            "&#123;&#123;appId&#125;&#125;"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"appSecret"</span>:{" "}
          <span className="attr-value mr-h-5">
            "&#123;&#123;appSecret&#125;&#125;"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">"Content-Type"</span>:{" "}
          <span className="attr-value mr-h-5">"application/json"</span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">response</span>{" "}
          <span className="mr-h-5 tag">=</span>
          <span className="attr-name">response</span>
          <span className="tag">.</span>
          <span className="attr-value">request</span>
          <span className="tag">(</span>
          <span className="attr-value">
            "{docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE}"
          </span>
          <span className="tag">,</span>
          <span className="attr-value mr-l-5">url</span>
          <span className="tag">,</span>
          <span className="attr-name mr-l-5">headers</span>
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">headers</span>
          <span className="tag">,</span>
          <span className="attr-name mr-l-5">data</span>
          <span className="mr-h-5 tag">=</span>
          <span className="attr-value">payload</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-value">print</span>
          <span className="tag">(</span>
          <span className="attr-name">response</span>
          <span className="tag">.</span>
          <span className="attr-value">text</span>
          <span className="tag">)</span>
        </p>
      </>
    );

    const goCode = (
      <>
        <p>
          <span className="attr-name">package</span>
          <span className="attr-value"> main</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">import</span>
          <span className="tag mr-l-5"> (</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-value">"fmt"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-value">"strings"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-value">"net/http"</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-value">"io/ioutil"</span>
        </p>
        <p className="mr-t-5">
          <span className="tag"> )</span>
        </p>
        <p className="mr-t-5">
          <span className="attr-name">fun</span>
          <span className="attr-value mr-h-5">main</span>
          <span className="tag">()</span>
          <span className="tag mr-h-5">&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">url</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-value mr-h-5">
            "{docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">method</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-value mr-h-5">
            "{docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE}"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">payload</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">strings</span>
          <span className="tag">.</span>
          <span className="attr-value">NewReader</span>
          <span className="tag">(`&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"token"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_TOKEN_HERE"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">
            "STATE_PASSED_IN_GET_URL_CALL_HERE"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;`)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">client</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">http</span>
          <span className="tag">.</span>
          <span className="attr-value">Client</span>
          <span className="tag mr-l-5">&#123;</span>
        </p>
        <p className="mr-l-20">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">req</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">err</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">http</span>
          <span className="tag">.</span>
          <span className="attr-value">NewRequest</span>
          <span className="tag">(</span>
          <span className="attr-name">method</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">url</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">payload</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">if</span>
          <span className="attr-name mr-h-5">err</span>
          <span className="tag">!=</span>
          <span className="attr-name mr-h-5">nil</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">fmt</span>
          <span className="tag">.</span>
          <span className="attr-value">Println</span>
          <span className="tag">(</span>
          <span className="attr-value">err</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">return</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">req.</span>
          <span className="tag">.</span>
          <span className="attr-name">Header</span>
          <span className="tag">.</span>
          <span className="attr-value">Add</span>
          <span className="tag">(</span>
          <span className="attr-name">"appId"</span>:{" "}
          <span className="tag mr-r-5">,</span>
          <span className="attr-value">"&#123;&#123;appId&#125;&#125;"</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">req.</span>
          <span className="tag">.</span>
          <span className="attr-name">Header</span>
          <span className="tag">.</span>
          <span className="attr-value">Add</span>
          <span className="tag">(</span>
          <span className="attr-name">"appSecret"</span>:{" "}
          <span className="tag mr-r-5">,</span>
          <span className="attr-value">
            "&#123;&#123;appSecret&#125;&#125;"
          </span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">req.</span>
          <span className="tag">.</span>
          <span className="attr-name">Header</span>
          <span className="tag">.</span>
          <span className="attr-value">Add</span>
          <span className="tag">(</span>
          <span className="attr-name">"Content-Type"</span>:{" "}
          <span className="tag mr-r-5">,</span>
          <span className="attr-value">"application/json"</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">req</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">err</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">client</span>
          <span className="tag">.</span>
          <span className="attr-value">Do</span>
          <span className="tag">(</span>
          <span className="attr-value">req</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">if</span>
          <span className="attr-name mr-h-5">err</span>
          <span className="tag">!=</span>
          <span className="attr-name mr-h-5">nil</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">fmt</span>
          <span className="tag">.</span>
          <span className="attr-value">Println</span>
          <span className="tag">(</span>
          <span className="attr-value">err</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">return</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">defer</span>
          <span className="attr-name mr-l-5">res</span>
          <span className="tag">.</span>
          <span className="attr-value">Body</span>
          <span className="tag">.</span>
          <span className="attr-value">Close</span>
          <span className="tag">()</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">body</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-name">err</span>
          <span className="tag mr-h-5">:=</span>
          <span className="attr-name">ioutil</span>
          <span className="tag">.</span>
          <span className="attr-value">ReadAll</span>
          <span className="tag">(</span>
          <span className="attr-name">res</span>
          <span className="tag">.</span>
          <span className="attr-value">Body</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="punctuation">if</span>
          <span className="attr-name mr-h-5">err</span>
          <span className="tag">!=</span>
          <span className="attr-name mr-h-5">nil</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">fmt</span>
          <span className="tag">.</span>
          <span className="attr-value">Println</span>
          <span className="tag">(</span>
          <span className="attr-value">err</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name">return</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">fmt</span>
          <span className="tag">.</span>
          <span className="attr-value">Println</span>
          <span className="tag">(</span>
          <span className="attr-name">string</span>
          <span className="tag">(</span>
          <span className="attr-value">body</span>
          <span className="tag">)</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;</span>
        </p>
      </>
    );

    const nodeCode = (
      <>
        <p>
          <span className="punctuation">var</span>
          <span className="attr-name mr-l-5">request</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-name">require</span>
          <span className="tag ">(</span>
          <span className="attr-value">'request'</span>
          <span className="tag ">)</span>
        </p>
        <p className="mr-t-5">
          <span className="punctuation">var</span>
          <span className="attr-name mr-l-5">options</span>
          <span className="tag mr-h-5">=</span>
          <span className="attr-name">&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">method:</span>
          <span className="attr-value">
            '{docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE}'
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name mr-h-5">url:</span>
          <span className="attr-value">
            '{docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}'
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">headers:</span>
          <span className="tag mr-h-5">:</span>
          <span className="tag">&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"appId"</span>:{" "}
          <span className="attr-value mr-h-5">
            "&#123;&#123;appId&#125;&#125;"
          </span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"appSecret"</span>:{" "}
          <span className="attr-value mr-h-5">
            "&#123;&#123;appSecret&#125;&#125;"
          </span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"Content-Type"</span>:{" "}
          <span className="attr-value mr-h-5">"application/json"</span>
        </p>
        <p className="mr-l-20">
          <span className="tag">&#125;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">body</span>
          <span className="tag mr-h-5">:</span>
          <span className="attr-name">JSON</span>
          <span className="tag">.</span>
          <span className="attr-value">stringify</span>
          <span className="tag">(&#123;</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"token"</span>:{" "}
          <span className="attr-value mr-h-5">"YOUR_TOKEN_HERE"</span>
        </p>
        <p className="mr-l-40 mr-t-5">
          <span className="attr-name mr-h-5">"state"</span>:{" "}
          <span className="attr-value mr-h-5">
            "STATE_PASSED_IN_GET_URL_CALL_HERE"
          </span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="tag">&#125;)</span>'
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;</span>'
        </p>
        <p className="mr-t-5">
          <span className="attr-name">request</span>
          <span className="tag">(</span>
          <span className="attr-value">options</span>
          <span className="tag mr-r-5">,</span>
          <span className="attr-value">function</span>
          <span className="tag">(</span>
          <span className="attr-value">error</span>
          <span className="tag mr-r-5">,</span>
          <span className="tag">)</span>
          <span className="tag mr-l-5">&#123;</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">if</span>
          <span className="tag mr-l-5">(</span>
          <span className="attr-value">error</span>
          <span className="tag">)</span>
          <span className="punctuation mr-h-5">throw</span>
          <span className="attr-name mr-h-5">new</span>
          <span className="attr-value mr-h-5">Error</span>
          <span className="tag mr-l-5">(</span>
          <span className="attr-value">error</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-l-20 mr-t-5">
          <span className="attr-name">conosle</span>
          <span className="tag">.</span>
          <span className="attr-value">log</span>
          <span className="tag">(</span>
          <span className="attr-name mr-h-5">response</span>
          <span className="tag">.</span>
          <span className="attr-value">body</span>
          <span className="tag">)</span>
        </p>
        <p className="mr-t-5">
          <span className="tag">&#125;)</span>
        </p>
      </>
    );

    const codeMap = {
      cURL: curlCode,
      Ruby: rubyCode,
      Python: pythonCode,
      Go: goCode,
      Node: nodeCode,
    };
    return codeMap[activeRequestLanguage];
  };

  const Endpoint = ({ urlType, url }) => {
    return (
      <FlexBox className="url">
        <p className="fs-14 method bg-dark-theme clr-white pd-10">{urlType}</p>
        <p className="fs-12 endpoint clr-white pd-10 word-break">{url}</p>
      </FlexBox>
    );
  };

  const WelcomeSection = (
    <div ref={WelcomeSectionRef}>
      <TitleBlock
        title={
          <FlexBox alignCenter className="section-header">
            <Image src={RestApiIcon} className="mr-r-10" />
            <p>{docsConstants.TITLES.API_REFERENCE.TITLE}</p>
          </FlexBox>
        }
        content={
          <p className="fs-16">
            Explore the details of the OTPless API. Our API is organised around
            REST principles and returns JSON-encoded responses, and uses
            standard HTTP response codes, authentication, and verbs.
          </p>
        }
        titleClass="fs-32 font-heavy"
        className="animated fadeInUp mr-b-60"
      />
    </div>
  );

  const RestApi = () => {
    const GetSignupUrl = (
      <div ref={GetSignupUrlRef}>
        <TitleBlock
          title={`1. ${docsConstants.TITLES.REST_API.INITIATE_LOGIN}`}
          content={
            <div className="api">
              <DocsFlexSectionBlock
                leftSection={
                  <>
                    <p className="fs-14 mr-b-20">
                      Used to get the WhatsApp Intent to verify the users mobile
                      number. An intent will be returned in the response that
                      will be used to redirect the user to WhatsApp with
                      prefilled text configured on the dashboard.
                    </p>
                    <Endpoint
                      urlType={
                        docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.TYPE
                      }
                      url={docsConstants.ENDPOINT.REST_API.INITIATE_LOGIN.URL}
                    />
                    <div className="headers mr-t-40">
                      <p className="border-top pd-10 fs-18 font-heavy">
                        Request Headers
                      </p>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">appId</p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          The{" "}
                          <span className="highlighted font-light pd-h-5">
                            appId
                          </span>{" "}
                          field signifies your app's ID. You can find it in your
                          app config under Application.
                        </p>
                      </div>
                    </div>
                    <div className="body mr-t-40">
                      <p className="border-top pd-10 fs-18 font-heavy">
                        Request Body
                      </p>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">loginMethod</p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          Always pass{" "}
                          <span className="font-medium">WHATSAPP</span> as value
                        </p>
                      </div>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">
                            redirectionURL{" "}
                            <span className="fs-12 italic">(optional)</span>
                          </p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          The url where user needs to be redirected to after
                          clicking on the link received on WhatsApp. If not set,
                          the redirection url set in the dashboard will be used.
                        </p>
                      </div>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">
                            state{" "}
                            <span className="fs-12 italic">
                              {" "}
                              (optional but recommended)
                            </span>
                          </p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          The{" "}
                          <span className="highlighted font-light pd-h-5">
                            state
                          </span>{" "}
                          parameter should be used to avoid forgery attacks,
                          pass in a value that's unique to the user you're
                          authenticating.
                        </p>
                      </div>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">
                            orderId{" "}
                            <span className="fs-12 italic">(optional)</span>
                          </p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          A string that the client can pass and it will be
                          returned as it on successful authentication. Can be
                          used to map session with the login process.
                        </p>
                      </div>
                    </div>
                    <div className="response mr-t-40">
                      <p className="border-top pd-10 fs-18 font-heavy">
                        Response fields
                      </p>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">intent</p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          <span className="highlighted font-light pd-h-5">
                            Intent
                          </span>{" "}
                          will be used to redirect the user on WhatsApp with
                          pre-filled text. User needs to send this text over
                          WhatsApp.
                        </p>
                      </div>
                    </div>
                  </>
                }
                rightSection={
                  <>
                    <DocsCodeBlock
                      title={getRequestHeader("GetSignupUrl")}
                      codeToBeCopied={
                        requestCodeToBeCopiedMap[activeRequestLanguage]
                      }
                      code={GetSignupUrlCode()}
                    />
                    <DocsCodeBlock
                      title={"Response"}
                      code={
                        <>
                          <p className="tag"> &#123;</p>
                          <p className="mr-l-20 mr-t-5">
                            <span className="attr-name mr-h-5">
                              "responseCode"
                            </span>
                            : <span className="attr-value mr-h-5">"200"</span>,
                          </p>
                          <p className="mr-l-20 mr-t-5">
                            <span className="attr-name mr-h-5">"message"</span>:{" "}
                            <span className="attr-value mr-h-5">
                              "Session initiated successfully"
                            </span>
                            ,
                          </p>
                          <p className="mr-l-20 mr-t-5">
                            <span className="attr-name mr-h-5">--data</span> '
                            <span className="tag">&#123;</span>
                          </p>
                          <p className="mr-l-40 mr-t-5">
                            <span className="attr-name mr-h-5">"intent"</span>:{" "}
                            <span className="attr-value mr-h-5">
                              "https://wa.me/911141169439?text=‎‌‍Hi%20WhatsApp%21%0APlease%20verify%20my%20number%20with%20test_application."
                            </span>
                          </p>
                          <p className="mr-l-20 mr-t-5">
                            <span className="tag">&#125;</span>'
                          </p>
                          <p className="mr-t-5 tag">&#125;</p>
                        </>
                      }
                      className="mr-t-40"
                    />
                  </>
                }
              />
            </div>
          }
          titleClass="fs-24 font-heavy"
        />
      </div>
    );

    const GetUserDetails = (
      <div ref={GetUserDetailsRef}>
        <TitleBlock
          title={`2. ${docsConstants.TITLES.REST_API.GET_USER_API}`}
          content={
            <div className="api">
              <p className="fs-14">
                Endpoint for getting user details after successful
                authentication
              </p>
              <DocsFlexSectionBlock
                leftSection={
                  <>
                    <Endpoint
                      urlType={
                        docsConstants.ENDPOINT.REST_API.GET_USER_DATA.TYPE
                      }
                      url={docsConstants.ENDPOINT.REST_API.GET_USER_DATA.URL}
                    />
                    <div className="headers mr-t-40">
                      <p className="border-top pd-10 fs-18 font-heavy">
                        Request Headers
                      </p>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">appId</p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          The{" "}
                          <span className="highlighted font-light pd-h-5">
                            appId
                          </span>{" "}
                          field signifies your app's ID. You can find it in your
                          app config under Application.
                        </p>
                      </div>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">appSecret</p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          The{" "}
                          <span className="highlighted font-light pd-h-5">
                            appSecret
                          </span>{" "}
                          field signifies your app's secret key. You can find it
                          in your app config under Application.{" "}
                          <span className="fs-12">
                            (AppSecret should not be exposed in any client side
                            application and should be only used in server side
                            applications to fetch user data)
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="body mr-t-40">
                      <p className="border-top pd-10 fs-18 font-heavy">
                        Request Body
                      </p>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">token</p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          Pass the{" "}
                          <span className="highlighted font-light pd-h-5">
                            token
                          </span>{" "}
                          received on the fronted from the redirection url.
                        </p>
                      </div>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">
                            state{" "}
                            <span className="fs-12 italic">(optional)</span>
                          </p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          Pass the same value that were passed in Get URL API.
                          (Only pass, if you have used this in Get URL API)
                        </p>
                      </div>
                    </div>
                    <div className="response mr-t-40">
                      <p className="border-top pd-10 fs-18 font-heavy">
                        Response fields
                      </p>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">responseCode</p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          The HTTP status code of the response. OTPless follows
                          standard HTTP response status code.
                        </p>
                      </div>
                      <div className="border-top pd-15">
                        <FlexBox alignCenter>
                          <p className="fs-16 font-medium">message</p>
                          <p className="fs-12 mr-l-10">string</p>
                        </FlexBox>
                        <p className="fs-14 mr-t-5">
                          The description of the response code.
                        </p>
                      </div>
                      <div className="border-top pd-t-15">
                        <Accordion
                          title={
                            <div className="">
                              <FlexBox alignCenter>
                                <p className="fs-16 font-medium">data</p>
                                <p className="fs-12 mr-l-10">Object</p>
                              </FlexBox>
                            </div>
                          }
                          content={
                            <>
                              <div className="border-top pd-v-15">
                                <FlexBox alignCenter>
                                  <p className="fs-16 font-medium">name</p>
                                  <p className="fs-12 mr-l-10">string</p>
                                </FlexBox>
                                <p className="fs-14 mr-t-5">Name of the user</p>
                              </div>
                              <div className="border-top pd-v-15">
                                <FlexBox alignCenter>
                                  <p className="fs-16 font-medium">mobile</p>
                                  <p className="fs-12 mr-l-10">string</p>
                                </FlexBox>
                                <p className="fs-14 mr-t-5">
                                  Verified Mobile Number of the user
                                </p>
                              </div>
                              <div className="border-top pd-v-15">
                                <FlexBox alignCenter>
                                  <p className="fs-16 font-medium">
                                    stateMatched
                                  </p>
                                  <p className="fs-12 mr-l-10">boolean</p>
                                </FlexBox>
                                <p className="fs-14 mr-t-5">
                                  This is the parameter tells whether user's
                                  state is matched or not.
                                </p>
                              </div>
                              <div className="border-top pd-v-15">
                                <FlexBox alignCenter>
                                  <p className="fs-16 font-medium">orderId</p>
                                  <p className="fs-12 mr-l-10">string</p>
                                </FlexBox>
                                <p className="fs-14 mr-t-5">
                                  This parameter contains the same string that
                                  was passed as orderId in the initiate call.
                                </p>
                              </div>
                              <div className="border-top pd-v-15">
                                <FlexBox alignCenter>
                                  <p className="fs-16 font-medium">state</p>
                                  <p className="fs-12 mr-l-10">string</p>
                                </FlexBox>
                                <p className="fs-14 mr-t-5">
                                  This parameter contains the same string that
                                  was passed as state in the initiate call.
                                </p>
                              </div>
                              <div className="border-top pd-t-15">
                                <FlexBox alignCenter>
                                  <p className="fs-16 font-medium">ip</p>
                                  <p className="fs-12 mr-l-10">string</p>
                                </FlexBox>
                                <p className="fs-14 mr-t-5">
                                  This parameter contains the ip address of the
                                  client from which the initiate call was made
                                  from
                                </p>
                              </div>
                            </>
                          }
                          defaultActive={true}
                        />
                      </div>
                    </div>
                  </>
                }
                rightSection={
                  <>
                    <DocsCodeBlock
                      title={getRequestHeader("GetUserDetails")}
                      codeToBeCopied={
                        requestGetUserDetailsCodeToBeCopiedMap[
                          activeRequestLanguage
                        ]
                      }
                      code={GetUserDetailsCode()}
                    />
                    <DocsCodeBlock
                      title={"Response"}
                      code={
                        <>
                          <p className="tag">&#123;</p>
                          <p className="mr-l-20 mr-t-5">
                            {" "}
                            <span className="attr-name mr-h-5">
                              "responseCode"
                            </span>
                            : <span className="attr-value mr-h-5">"200"</span>,
                          </p>
                          <p className="mr-l-20 mr-t-5">
                            <span className="attr-name mr-h-5">"message"</span>:{" "}
                            <span className="attr-value mr-h-5">
                              "Session verified"
                            </span>
                            ,
                          </p>
                          <p className="mr-l-20 mr-t-5">
                            <span className="attr-name mr-h-5">data</span> '
                            <span className="tag">&#123;</span>
                          </p>
                          <p className="mr-l-40 mr-t-5">
                            <span className="attr-name mr-h-5">"name"</span>:{" "}
                            <span className="attr-value mr-h-5">"Riya"</span>
                          </p>
                          <p className="mr-l-40 mr-t-5">
                            <span className="attr-name mr-h-5">"mobile"</span>:{" "}
                            <span className="attr-value mr-h-5">
                              "918882271794"
                            </span>
                          </p>
                          <p className="mr-l-40 mr-t-5">
                            <span className="attr-name mr-h-5">
                              "stateMatched"
                            </span>
                            : <span className="attr-value mr-h-5">false</span>
                          </p>
                          <p className="mr-l-40 mr-t-5">
                            <span className="attr-name mr-h-5">"orderId"</span>:{" "}
                            <span className="attr-value mr-h-5">null</span>
                          </p>
                          <p className="mr-l-40 mr-t-5">
                            <span className="attr-name mr-h-5">"state"</span>:{" "}
                            <span className="attr-value mr-h-5">
                              "8b599492-a3a0-47a7-a795-725e3b746f581666780397"
                            </span>
                          </p>
                          <p className="mr-l-40 mr-t-5">
                            <span className="attr-name mr-h-5">"ip"</span>:{" "}
                            <span className="attr-value mr-h-5">
                              "192.169.137.141"
                            </span>
                          </p>
                          <p className="mr-l-20 mr-t-5">
                            <span className="tag">&#125;</span>'
                          </p>
                          <p className="mr-t-5 tag">&#125;</p>
                        </>
                      }
                      className="mr-t-40"
                    />
                  </>
                }
                className={"mr-t-40"}
              />
            </div>
          }
          titleClass="fs-24 font-heavy mr-t-40 pd-t-20 dashed-border-top"
        />
      </div>
    );

    const PostmanCollection = (
      <div ref={PostmanRef}>
        <TitleBlock
          title={`3. ${docsConstants.TITLES.REST_API.POSTMAN_COLLECTION}`}
          content={
            <div className="api">
              <p className="fs-14">
                You can use the official OTPless Postman collection to test and
                learn about the OTPless API before writing any code. The
                workspace includes requests for all of OTPless's API endpoints.
                Find it{" "}
                <a
                  className="underline clicking-animation"
                  href={docsConstants.ENDPOINT.REST_API.POSTMAN.URL}
                  target="_self"
                >
                  here
                </a>{" "}
                !
              </p>
            </div>
          }
          titleClass="fs-24 font-heavy mr-t-40 pd-t-20 dashed-border-top"
        />
      </div>
    );

    return (
      <TitleBlock
        title={""}
        content={
          <div className="rest-api-sdk">
            {GetSignupUrl}
            {GetUserDetails}
            {PostmanCollection}
          </div>
        }
        titleClass="fs-24 font-heavy"
        className="animated fadeInUp delay-01s border-top mr-b-60 mr-t-60 pd-t-30"
      />
    );
  };

  //Return UI
  return (
    <DocsScreen
      className="docs-home-screen docs-api-screen"
      hasSideMenu
      hasHeader
      screenAnimationClass="no-animation"
      tabSelectCallback={scrollToSpecificElement}
      scrolledToElement={{ ...scrolledToElement }}
    >
      {WelcomeSection}
      {RestApi()}
    </DocsScreen>
  );
};

export default DocsHome;
